const getColumnPadding = (column) => {
  if (column.disablePadding) {
    return { padding: 0 };
  }

  if (column.leftPaddingOnly) {
    return { paddingRight: 0 };
  }

  if (column.rightPaddingOnly) {
    return { paddingLeft: 0 };
  }

  if (column.rightPaddingAndDisableXAxis) {
    return { paddingLeft: 0, paddingTop: 0, paddingBottom: 0 };
  }

  return {};
};

const PAGINATION_LOCATION = {
  TOP: 'top',
  BOTTOM: 'bottom',
  BOTH: 'both',
};

const expandActionColumn = {
  id: 'expandedActionColumn',
  label: '',
  disableSort: true,
};

// SortableTable only auto-paginates above twice the page size — a single overflowing page would put a
// pager over rows the user can already scroll to. Callers that must line up with that rule (a search
// box that should only appear alongside real pagination) call this instead of re-deriving the
// multiplier. Note it describes auto-pagination only: an explicit `paginationProps` overrides it.
const shouldAutoPaginate = (rowCount, rowsPerPage) => Boolean(rowsPerPage) && rowCount >= rowsPerPage * 2;

export { expandActionColumn, getColumnPadding, PAGINATION_LOCATION, shouldAutoPaginate };
